/**
 * Contexto de sesión por rol — andamiaje de los dos planos (E3).
 *
 * En esta etapa el contexto sostiene la sesión y permite entrar a cada plano por
 * rol. En fase Core lo alimenta `app/frontend/src/lib/api.ts` vía GoTrue/REST
 * y MFA recomendado; la estructura de planos no cambia.
 */
import { createContext, useContext } from "react";

export type Rol = "ventas" | "rec" | "admin" | "auditor";

/** Sesión normalizada del frontend para RLS y ruteo por rol. */
export interface Session {
  userId: string;
  tenantId: string;
  rol: Rol;
  email?: string;
  nombre?: string;
  /** JWT para las llamadas de datos (RLS). Vacío en modo demostración local. */
  accessToken: string;
  /** Refresh token de GoTrue. En demo no existe. */
  refreshToken?: string;
  /** Expiración del accessToken en epoch ms. Permite renovar antes de caer. */
  expiresAt?: number;
  /**
   * Nivel de autenticación del JWT. "aal2" = ya pasó MFA TOTP; "aal1" =
   * password normal. RLS se acota por tenant_id; MFA no es requisito de acceso.
   * "demo" = sesión de demostración local sin backend (aal no aplica).
   */
  aal: "aal1" | "aal2" | "demo";
}

export interface AuthState {
  session: Session | null;
  authError: string | null;
  setSession: (s: Session | null) => void;
}

export const AuthContext = createContext<AuthState | null>(null);

export function useAuth(): AuthState {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth debe usarse dentro de <AuthProvider>");
  }
  return ctx;
}
